import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { jarvisPrimeDashboardActions } from "stores/jarvisPrime/jarvisPrimeDashboard/jarvisPrimeDashboardActions";

const mapStateToProps = (state) => {
    
    return {
        portfolioSector: state.jarvisPrime.primeDashboard.portfolioSector
    };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
    getPortfolioSectorAction : jarvisPrimeDashboardActions.getPortfolioSector
}, dispatch)

const SectorDiversificationStore = (Container) => connect(mapStateToProps, mapDispatchToProps)(Container);
export default SectorDiversificationStore;